import * as THREE from "three";
import { useEffect, useCallback, useRef, useState } from "react";
import {useSitePropertiesStore} from "../../store/useGeometryPropertiesStore.js"
import { useMapStore } from "../../store/useMapStore.js";
import NotificationBanner from "../../Components/UserInterface/Notificationbar.jsx";
import { useBoundingBoxStore } from "../../store/useBoundingBoxStore.js";
import fetchFlurstueckData from "../sites/Sitequeries.js";
import PolygonPlane from "./SiteGeometry.jsx";
import { useSiteExportStore } from "../../store/useSiteExport.js";
import { useLayerStore } from "../../store/useLayerStore.js";
import { useEntityStore } from "../../store/useExportStore.js";
import { useGeometryTypeStore } from "../../store/useGeometryPropertiesStore.js";
import GUI from "lil-gui";
import { CacheGeometry, LoadFromCache, GetCacheKey, ClearCache } from "../../utils/GeometryHelper.js";
import { Html } from '@react-three/drei';
import { Stage, GeometryType } from "../../constants/progress.js";
import { useProgressStore } from "../../store/progressStore.js";


export default function FlurstuckGeometry() 
{
  const { setGeometryType } = useGeometryTypeStore();
 
  const geometryType = GeometryType.SITE_PLOTS;
  const scalingFactor = useMapStore(state => state.scalingFactor);
  const setflurstuckEntitiesExport = useSiteExportStore((state) => state.setParcelEntities);
  const visibleLayers = useLayerStore((state) => state.visibleLayers);
  const [crs, setCrs] = useState("EPSG25832"); 
  const [flurstuckEntities, setFlurstuckEntities] = useState([]);  
  const boundingBoxNE = useBoundingBoxStore(state => state.ne);
  const boundingBoxSW = useBoundingBoxStore(state => state.sw);
  const [selectedEntityId, setSelectedEntityId] = useState(null);
  const updateSitePropertiesStore = useSitePropertiesStore((state) => state.updateSiteProperties);
  const CACHE_KEY = "cacheParcel";
  const CACHE_VERSION = "version_1";
  const cacheKey = GetCacheKey(boundingBoxNE,boundingBoxSW,crs, CACHE_KEY,CACHE_VERSION)
  
 
  const fetchData = async () => {
      try {
         let data = LoadFromCache (cacheKey, CACHE_VERSION, 1000 * 60 * 60 * 24) 
         
         if(!data)
         {
            data = await fetchFlurstueckData(
            boundingBoxNE.lng,
            boundingBoxNE.lat,
            boundingBoxSW.lng,
            boundingBoxSW.lat,
            crs
            );
            if (data && data.length > 0) {
      
            const newData = data.map(item => ({...item}));
            
            setFlurstuckEntities(newData);
            setflurstuckEntitiesExport(newData);
            ClearCache(CACHE_KEY);
            CacheGeometry(boundingBoxNE,boundingBoxSW,crs, "cacheParcel", "version_1", data);
            console.log("Number of Parcels recieved ",data.length);
          }
         }
         else{

          const newData = data.map(item => ({...item}));
          setFlurstuckEntities(newData);
          setflurstuckEntitiesExport(newData);
        }
      } catch (error) {
        console.error('Failed to fetch data:', error);
      }
    };
  
  const handleEntitySelect = (entity) => 
    {
     // console.log("handleEntitySelect called with:", entity); // Debug log
  
      setSelectedEntityId(entity.id);
      setGeometryType(entity.Name);
      setSelectedEntityId(entity.id);
      setGeometryType(entity.Name);
      updateSitePropertiesStore(
      entity.amtlicheFlaeche,
      entity.flurnummer,
      entity.flurstücknummer,
      entity.gemarkungName,
      entity.gemarkungSchluessel,
      entity.gemeindeSchluessel,
      entity.baugebiet,
      entity.nutzungsart,
      entity.gfz,
      entity.bmz,
      entity.grz,
      entity.erdbebenzone,
      entity.untergrundklasse,
      entity.windlastzone,
      entity.schneelastzone,
      entity.abstandflaechen,
      entity.grundstuecksflaeche,
      )
    };
  
  

  // Run on mount
  useEffect(() => 
    {
      fetchData();
       console.log("Runs once on refresh / first render");
   }, []);

   
  return (
    <>
      <group>
      {flurstuckEntities.length > 0 && (
      <PolygonPlane 
        entities={flurstuckEntities}
        selectedEntityId={selectedEntityId}
        setSelectedEntityId={setSelectedEntityId}
        scalingFactor={scalingFactor}
        inputColor={"#ababab"}
        inputVisibilty={visibleLayers.flurstucke}
        onEntitySelect={handleEntitySelect}
        className = {"FlurstuckEntity"}
        crs={crs}
        geometryType={geometryType}
        zTransform = {[0,0,0]}
      />
    )}
    </group>
    </>
  );
}
